import { db } from '../../config/firebase/config';
import { auth } from '../../config/firebase/auth';
import { collection, getDocs, getDoc, updateDoc, doc } from 'firebase/firestore';

export async function addRestaurantIdToOldMesas() {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("Usuario no autenticado");

    const userDocRef = doc(db, 'users', user.uid);
    const userSnapshot = await getDoc(userDocRef);
    if (!userSnapshot.exists()) throw new Error("Usuario no encontrado");

    const restaurantId = userSnapshot.data().restaurantId;
    if (!restaurantId) throw new Error("restaurantId no está definido");

    const snapshot = await getDocs(collection(db, 'mesas'));
    const mesasToUpdate = snapshot.docs.filter(doc => !doc.data().restaurantId);

    console.log(`⏳ ${mesasToUpdate.length} mesas por actualizar`);

    for (const mesa of mesasToUpdate) {
      await updateDoc(mesa.ref, { restaurantId });
      console.log(`✅ Mesa ${mesa.id} actualizada`);
    }

    console.log("🎉 Migración completada");
  } catch (error) {
    console.error("❌ Error:", error);
  }
}
